import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class IosUserEventService {

  constructor(private http: HttpRequestService) { }
  gets(parameters) {
    return this.http.get('getListUserEventRequestActive', parameters)
        .map(res => {
          return res.json();
        })
  }

  get(id, botId) {
    return this.http.get(`getUserEventByID?id=${id}&bot_id=${botId}`)
        .map(res => {
          return res.json();
        })
  }

  active(model: any) {
    return this.http.put(`editUserEventById`, model).map(res => {
      return res.json();
    });
  }

  disable(model: any) {
    return this.http.put(`cancelUserEventById`, model).map(res => {
      return res.json();
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/ios-user-event.service.ts